import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { canAccess } from "../config/roles";

/** Blocks access until a user is logged in; redirects to /login otherwise. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center gap-3 bg-background-50">
        <span className="flex h-11 w-11 animate-pulse items-center justify-center rounded-lg bg-primary-500 text-xl text-white">
          <i className="ri-bank-card-line" />
        </span>
        <p className="text-sm text-foreground-500">Loading workspace…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}

/** Redirects users without the required role/nav access to the 403 page. */
export function RequireNav({ navKey, children }: { navKey: string; children: ReactNode }) {
  const { role } = useAuth();
  if (!canAccess(role, navKey)) {
    return <Navigate to="/403" replace />;
  }
  return <>{children}</>;
}